import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "bootstrap/dist/css/bootstrap.min.css";

const BASE_IMAGE_URL = "http://103.235.105.54/admin/uploads/items/";

const stripePromise = loadStripe("pk_test_51S5lLlBC6Zxi4ic3koi4d5K240VWYJw6iI193Ev5hCEgHlB1iM7qbDSi2yPPneXAN0tj2qotaug6GFxaVH9rnVhj00Mmyr9Nfh");

const TestPay = () => {
  const { order_id } = useParams();
  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [splitValue, setSplitValue] = useState(1); // ✅ default = 1
  const [totalAmount, setTotalAmount] = useState(0);
  const [posLoading, setPosLoading] = useState(false);
  const [result, setResult] = useState(null);
const [paidSplits, setPaidSplits] = useState([]);
  useEffect(() => {
    const savedData = sessionStorage.getItem("orderResponse");
    if (savedData) {
      const data = JSON.parse(savedData);
      if (data.status && data.data.length > 0) {
        const orderData = data.data[0];
         console.log("Loaded from session:", data);
        setOrder(orderData);
        setTotalAmount(orderData.total_price || 0.0);

        // ✅ use your image parse logic
        const formattedItems = orderData.items.map((item) => {
          let imgSrc = "assets/images/foods/foods.png";
          try {
            if (item.images && item.images !== "") {
              const imgs = parseImages(item.images);
              if (imgs.length > 0) {
                imgSrc = BASE_IMAGE_URL + imgs[0];
              }
            }
          } catch (e) {
            console.warn("Image parse error:", e);
          }

          return {
            ...item,
            img: imgSrc,
            qty: parseInt(item.qty, 10),
            baseprice: parseFloat(item.baseprice),
          };
        });

        setOrderItems(formattedItems);
      }
    }
  }, []);

  const parseImages = (images) => {
    try {
      let parsed = JSON.parse(images); // first parse
      if (typeof parsed === "string") {
        // if still a string, parse again
        parsed = JSON.parse(parsed);
      }
      return parsed;
    } catch (e) {
      console.error("Image parse error:", e, images);
      return [];
    }
  };

  const handleIncrease = () => setSplitValue((prev) => prev + 1);
  const handleDecrease = () => {
    if (splitValue > 1) setSplitValue((prev) => prev - 1);
  };

  // ✅ per-split amount (never more than total)
  const splitAmounts = Array.from({ length: splitValue }, (_, i) => {
    const baseSplit = totalAmount / splitValue;
    return i === splitValue - 1
      ? (totalAmount - baseSplit * (splitValue - 1)).toFixed(2) // last split gets remainder
      : baseSplit.toFixed(2);
  });

  const handlePOSPayment = async (amount) => {
    try {
      setPosLoading(true);
      const res = await fetch("http://103.235.105.54/admin/api/purchase", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          total_amount: amount,
          branch_id: sessionStorage.getItem("branch_id"),
          company_id: sessionStorage.getItem("company_id"),
          order_id: order.id,
          customer_id: 1,
          pos_prints_receipt: true,
        }),
      });
      const data = await res.json();
      setResult(data.external_data.receipt);
      alert(`POS Payment success for ₹${amount}`);
    } catch (err) {
      console.error("POS Payment Error:", err);
      alert("POS Payment failed!");
    } finally {
      setPosLoading(false);
    }
  };

  const handleCashPayment = async (amount) => {
    try {
      const res = await fetch("http://103.235.105.54/admin/api/cashPurchase", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          total_amount: amount,
          branch_id: sessionStorage.getItem("branch_id"),
          company_id: sessionStorage.getItem("company_id"),
          order_id: order.id,
          customer_id: 1,
          cash_amount: amount,
          pos_prints_receipt: false,
        }),
      });
      const data = await res.json();
      setResult(data);
      alert(`Cash Payment success for ₹${amount}`);
    } catch (err) {
      console.error("Cash Payment Error:", err);
      alert("Cash Payment failed!");
    }
  };

  return (
    <main className="main-wrapper">
      <div className="container-fluid">
        <div className="row g-8">
          {/* Left column: items */}
            {/* Left Column: Order Summary */}
           <div className="col-lg-6">
              <div className="order-box p-3 border rounded shadow-sm">
                <div className="d-flex justify-content-between mb-3">
                  <div className="order-header">
                    Order’s Summary 
                  </div>
                  <div>
                    <input type="checkbox" defaultChecked /> Select All
                  </div>
                </div>

                {/* Order Items */}
         {order.items?.map((item, index) => {
  // Safely parse images
  let imgs = [];
  try {
    //imgs = JSON.parse(JSON.parse(item.images)); // because your API double-encodes
   imgs = parseImages(item.images);
  } catch (e) {
    imgs = []; 
  }

  const imgSrc =
    imgs.length > 0
      ? BASE_IMAGE_URL + imgs[0]
      : "assets/images/foods/foods.png";

  return (
    <div
      key={index}
      className="order-item d-flex justify-content-between align-items-center mb-3"
    >
      <div className="d-flex align-items-center gap-2">
        <img
          src={imgSrc}
          alt={item.item_name}
          style={{ width: "60px", height: "60px", objectFit: "cover" }}
          className="rounded"
        />
        <div>
          <div className="title fw-semibold">{item?.item_name}-{item.netprice}</div>
          <small>
            (₹{item.baseprice}) × {item.qty}
          </small>{" "}
          
          <small>= ₹{(item.baseprice * item.qty).toFixed(2)}</small>
        </div>
      </div>
      <input type="checkbox" defaultChecked />
    </div>
  );
})}

                {/* Payment Summary */}
                <div className="mt-4">
                  <h6 className="fw-bold">Payment Summary</h6>
                  <div className="d-flex justify-content-between">
                    <span>Tax</span>
<span className="text-primary">
  ₹{(
    (parseFloat(order?.cgst) || 0) +
    (parseFloat(order?.sgst) || 0) +
    (parseFloat(order?.igst) || 0) +
    (parseFloat(order?.vat) || 0) +
    (parseFloat(order?.tax) || 0)
  ).toFixed(2)}
</span>

                  </div>
                   <div className="d-flex justify-content-between">
                    <span>Discount</span>
                    <span className="text-primary">₹
                      {order?.discount ? order.discount : "0.00"}
                    
                      </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Total</span>
                    <span className="text-primary">
                      {order?.total_price ? order.total_price : "0.00"}
                      {/* ₹{totalAmount.toFixed(2)} */}
                      </span>
                  </div>
                </div>
              </div>
            </div>

          {/* Right column: split payments */}
          <div className="col-lg-6">
            <div className="summary-box p-3 border rounded shadow-sm">
              <h4>Total: ₹{(parseFloat(order?.total_price) || 0).toFixed(2)}</h4>

              {/* Split controls */}
              <div className="mt-3">
                <h6>Number of Splits</h6>
                <div className="d-flex align-items-center gap-2">
                  <button className="btn btn-outline-secondary" onClick={handleDecrease}>-</button>
                  <div className="px-3 py-1 border rounded bg-light">{splitValue}</div>
                  <button className="btn btn-outline-secondary" onClick={handleIncrease}>+</button>
                </div>
              </div>

              {/* Split rows */}
             <div className="mt-3">
  {splitAmounts.map((amt, i) => (
    <div
      key={i}
      className="d-flex justify-content-between align-items-center mb-2"
    >
      <span>
        Split {i + 1} —{" "}
        {paidSplits.includes(i) ? (
          <span className="text-success fw-bold">Paid</span>
        ) : (
          <span>₹{amt}</span>
        )}
      </span>
      <div className="d-flex gap-2">
        <button
          className="btn btn-sm btn-success"
          disabled={paidSplits.includes(i) || posLoading}
          onClick={() => {
            handlePOSPayment(amt);
            setPaidSplits([...paidSplits, i]); // ✅ mark as paid
          }}
        >
          POS ₹{amt}
        </button>
        <button
          className="btn btn-sm btn-primary"
          disabled={paidSplits.includes(i)}
          onClick={() => {
            handleCashPayment(amt);
            setPaidSplits([...paidSplits, i]); // ✅ mark as paid
          }}
        >
          Cash ₹{amt}
        </button>
      </div>
    </div>
  ))}
</div>

              {/* Payment result */}
              {result && (
                <div className="mt-3">
                  <h6>Payment Response</h6>
                  <pre style={{ whiteSpace: "pre-wrap" }}>
                    {typeof result === "string"
                      ? result
                      : JSON.stringify(result, null, 2)}
                  </pre>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TestPay